var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 9.25C5.08579 9.25 4.75 9.58578 4.75 10C4.75 10.4142 5.08579 10.75 5.5 10.75V9.25ZM15.5 10L16.0303 10.5303C16.171 10.3897 16.25 10.1989 16.25 10C16.25 9.80108 16.171 9.61032 16.0303 9.46967L15.5 10ZM11.0303 4.46967C10.7374 4.17678 10.2626 4.17678 9.96967 4.46967C9.67678 4.76256 9.67678 5.23744 9.96967 5.53033L11.0303 4.46967ZM9.96967 14.4697C9.67678 14.7626 9.67678 15.2374 9.96967 15.5303C10.2626 15.8232 10.7374 15.8232 11.0303 15.5303L9.96967 14.4697ZM5.5 10.75L15.5 10.75L15.5 9.25L5.5 9.25V10.75ZM16.0303 9.46967L11.0303 4.46967L9.96967 5.53033L14.9697 10.5303L16.0303 9.46967ZM14.9697 9.46967L9.96967 14.4697L11.0303 15.5303L16.0303 10.5303L14.9697 9.46967Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForth);
export default __webpack_public_path__ + "static/media/forth.b59a34c937a631ed63c5a7ca903d162c.svg";
export { ForwardRef as ReactComponent };